import _ from 'lodash';

export const addBrandPostfixConditionally = (core: string, postfix?: string) =>
  `${core}${
    postfix && !postfix.startsWith('template') ? `_${_.snakeCase(postfix)}` : ''
  }`;
